export { HeroContent, type HeroContentProps } from "./HeroContent";
